// extracted by mini-css-extract-plugin
export default {"copy-icon":"_1SCDP","copyIcon":"_1SCDP"};